import { ExternalControlType } from "../controls/externalControl";

const isExternalControl = (control: string | Record<string, unknown>) =>
  typeof control === "string" &&
  Object.values(ExternalControlType).includes(control as ExternalControlType);

export default isExternalControl;
